"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpClientContactDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_details_entry_entity_1 = require("./opportunity-rfp-details-entry.entity");
const opportunity_rfp_client_contact_influencers_entity_1 = require("./opportunity-rfp-client-contact-influencers.entity");
let OpportunityRfpClientContactDetail = class OpportunityRfpClientContactDetail {
};
exports.OpportunityRfpClientContactDetail = OpportunityRfpClientContactDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "opportunity_rfp_details_entry_id",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "opportunityRfpDetailsEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "expected_premium",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "expectedPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityRfpClientContactDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityRfpClientContactDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityRfpClientContactDetail.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_rfp_details_entry_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry !== "undefined" && opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry) === "function" ? _d : Object)
], OpportunityRfpClientContactDetail.prototype, "opportunityRfpDetailsEntry", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_client_contact_influencers_entity_1.OpportunityRfpClientContactInfluencers, (influencer) => influencer.clientContact),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpClientContactDetail.prototype, "clientContactInfluencers", void 0);
exports.OpportunityRfpClientContactDetail = OpportunityRfpClientContactDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_client_contact_detail" })
], OpportunityRfpClientContactDetail);
